import { render, staticRenderFns } from "./createdoc_payment_trans.vue?vue&type=template&id=4ea5cc67&lang=true&"
import script from "./createdoc_payment_trans.vue?vue&type=script&lang=js&"
export * from "./createdoc_payment_trans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports